// ============================================================================
// Construction PURE de l'ordre des lignes communes d'une carte de plan
// (page d'abonnement) — testable sans rendu de composant. Le mapping
// icône/libellé reste dans `SubscriptionPage.tsx` (JSX).
//
// Règle (2026-10-01, contrat
// docs/superpowers/api-changelog/2026-10-01-vestiaire-acces-par-plan.md) :
// la ligne Vestiaire Collective suit toujours la ligne veilles (présente ou
// non selon le plan), jamais ailleurs, et porte `excluded` quand le plan n'a
// pas `vestiaireAccess`.
// ============================================================================

export type SharedFeatureRowKind = 'productSearches' | 'vendorSearches' | 'veilles' | 'vestiaire' | 'image';

export interface SharedFeatureRow {
  kind: SharedFeatureRowKind;
  /** Vrai seulement pour la ligne Vestiaire d'un plan sans accès. */
  excluded?: boolean;
}

export const buildSharedFeatureRows = ({
  veilleQuota,
  vestiaireAccess,
}: {
  veilleQuota: number | undefined;
  vestiaireAccess: boolean | undefined;
}): SharedFeatureRow[] => [
  { kind: 'productSearches' },
  { kind: 'vendorSearches' },
  ...(veilleQuota != null ? [{ kind: 'veilles' } as const] : []),
  // Absent ou faux ⇒ exclue (contrat : un plan sans vestiaireAccess n'a pas l'accès).
  { kind: 'vestiaire', excluded: vestiaireAccess !== true },
  { kind: 'image' },
];
